export default __webpack_public_path__ + "static/media/pos.41dd2cbf.svg";